<!--Scroll to top-->
<div class="scroll-to-top" [class]="{'show-scrollTop': windowScrolled}">
    <button (click)="scrollToTop()">
      <i class="fa fa-chevron-up"></i>
  </button>
</div>
